import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { sectionHook } from '../../lib/domHooks';

/**
 * Paris şemasının bölüm kabuğu.
 *
 * Referans arayüzde başlığın hemen yanında kategorinin **kalan oyun sayısı**
 * bir rozet olarak durur ("+6324") ve tam listeye gider; şeridin sağ ucunda da
 * kaydırma okları vardır. Rozet yalnızca sayı bilindiğinde çizilir — şeritte
 * görünenden fazlası yoksa "+0" yazmak yerine hiç çizilmez.
 */
const ParisSection = ({
  title, to, count = null, shown = 0, wide = false, section, children,
}) => {
  const stripRef = useRef(null);

  const scroll = (direction) => {
    const el = stripRef.current;
    if (!el) return;
    el.scrollBy({ left: direction * Math.max(el.clientWidth * 0.8, 240), behavior: 'smooth' });
  };

  const remaining = Number.isFinite(count) ? Math.max(0, count - shown) : 0;

  return (
    <section className="paris-section" {...sectionHook(section)}>
      <div className="paris-section-head">
        <h2 className="paris-section-title">{title}</h2>
        {to && remaining > 0 && (
          <Link to={to} className="paris-section-count" aria-label={`${title} — tümünü gör`}>
            {`+${remaining}`}
          </Link>
        )}
        {to && remaining === 0 && (
          <Link to={to} className="paris-section-more">Tümü</Link>
        )}
        <div className="paris-section-nav">
          <button
            type="button"
            className="paris-nav-arrow"
            onClick={() => scroll(-1)}
            aria-label="Önceki"
          >
            <ChevronLeft size={16} />
          </button>
          <button
            type="button"
            className="paris-nav-arrow"
            onClick={() => scroll(1)}
            aria-label="Sonraki"
          >
            <ChevronRight size={16} />
          </button>
        </div>
      </div>
      <div className={`paris-strip ${wide ? 'is-wide' : ''}`} ref={stripRef}>
        {children}
      </div>
    </section>
  );
};

export default ParisSection;
